export default __webpack_public_path__ + "static/media/0x7cb810ecbfd6125e65f451cfbd8ae657dffdd6b4.f99afe99.webp";